import * as React from "react";
import { Box } from "@stenajs-webui/core";
import { cssColor } from "@stenajs-webui/theme";
import { Spinner } from "./Spinner";

export interface SpinnerImageProps {
  imageUrl: string;
}

export const SpinnerImage: React.FC<SpinnerImageProps> = ({ imageUrl }) => {
  return (
    <Box
      background={cssColor("--silver-lighter")}
      position={"relative"}
      overflow={"hidden"}
    >
      <img src={imageUrl} alt={""} style={{ filter: "blur(10px)" }} />
      <Box
        top={0}
        bottom={0}
        left={0}
        right={0}
        position={"absolute"}
        justifyContent={"center"}
        alignItems={"center"}
        background={"rgba(255, 255, 255, 0.7)"}
      >
        <Spinner />
      </Box>
    </Box>
  );
};
